/**
 * 维度图标弹窗「国家」类：用 Intl + 少量特殊项展示名称，避免为每个 code 写 i18n。
 */

const LOCALE_BUCKET: Record<string, 'zh-CN' | 'en-US'> = {
  'zh-cn': 'zh-CN',
  'zh_cn': 'zh-CN',
  zh: 'zh-CN',
  'en-us': 'en-US',
  'en_us': 'en-US',
  en: 'en-US',
};

function resolveBucket(locale: string): 'zh-CN' | 'en-US' {
  const key = locale?.toLowerCase?.() ?? 'en-US';
  return LOCALE_BUCKET[key] || (key.startsWith('zh') ? 'zh-CN' : 'en-US');
}

const SPECIAL_LABELS: Record<string, Record<'zh-CN' | 'en-US', string>> = {
  global: { 'zh-CN': '全球', 'en-US': 'Global' },
  global2: { 'zh-CN': '全球', 'en-US': 'Global' },
  'global-16': { 'zh-CN': '全球', 'en-US': 'Global' },
  global_wo_china: { 'zh-CN': '全球（不含中国）', 'en-US': 'Global (excl. China)' },
  others: { 'zh-CN': '其他', 'en-US': 'Others' },
  'gb-eng': { 'zh-CN': '英格兰', 'en-US': 'England' },
  'gb-nir': { 'zh-CN': '北爱尔兰', 'en-US': 'Northern Ireland' },
  'gb-sct': { 'zh-CN': '苏格兰', 'en-US': 'Scotland' },
  'gb-wls': { 'zh-CN': '威尔士', 'en-US': 'Wales' },
};

const REGION_DISPLAY_NAMES_CACHE = new Map<string, Intl.DisplayNames | null>();

function getRegionDisplayNames(locale: string): Intl.DisplayNames | null {
  if (REGION_DISPLAY_NAMES_CACHE.has(locale)) {
    return REGION_DISPLAY_NAMES_CACHE.get(locale) || null;
  }
  try {
    const formatter = new Intl.DisplayNames([locale], { type: 'region' });
    REGION_DISPLAY_NAMES_CACHE.set(locale, formatter);
    return formatter;
  } catch {
    REGION_DISPLAY_NAMES_CACHE.set(locale, null);
    return null;
  }
}

/**
 * @param code — SHOW_DIMENSION_ICON_MAP 中国家类 key（小写，如 cn、gb-eng）
 */
export function formatCountryDimensionIconName(
  code: string,
  locale: string,
): string {
  const lc = code.toLowerCase();
  const bucket = resolveBucket(locale);
  const special = SPECIAL_LABELS[lc]?.[bucket];
  if (special) {
    return special;
  }

  try {
    if (/^[a-z]{2,3}$/i.test(code)) {
      const formatter = getRegionDisplayNames(locale);
      const name = formatter?.of(code.toUpperCase());
      if (name) {
        return name;
      }
    }
  } catch {
    // Intl 不可用时退回 code
  }

  return code.toUpperCase();
}
